import {numUtil} from './num';

export const orderUtil = {
  isConditionalOrder(ordType) {
    return ['Stop', 'StopLimit', 'LimitIfTouched', 'MarketIfTouched', 'BoSlLimit', 'BoSlMarket'].indexOf(ordType) > -1;
  },
  isLimitOrder(ordType) {
    return ['Bracket', 'StopLimit', 'LimitIfTouched', 'BoTpLimit', 'BoSlLimit'].indexOf(ordType) > -1;
  },
  isMarketOrder(ordType) {
    return ['Market', 'Stop', 'MarketIfTouched', 'BoSlMarket'].indexOf(ordType) > -1;
  },
  isBracketOrders(ordType) {
    return ['Bracket', 'BoTpLimit', 'BoSlLimit', 'BoSlMarket'].indexOf(ordType) > -1;
  },
  isFinalOrder(ordStatus) {
    return ['Deactivated', 'Filled', 'Canceled', 'Rejected'].indexOf(ordStatus) > -1;
  },
  isActivation(ordStatus, pegPriceType) {
    return pegPriceType === 'TrailingTakeProfitPeg' && ordStatus === 'Inactive';
  },
  formatOrderQty(orderQty) {
    return orderQty > 0 ? numUtil.delimit(orderQty) : 'PositionSize';
  },
};
